/**
 * Store Pinia — snackbar
 *
 * Migré depuis `store/modules/snackbar.js`. Gère l'affichage du snackbar global.
 * Non persisté (notification éphémère).
 *
 * Équivalences Vuex → Pinia :
 *   - getters.getSnackBarInfo → getters.getSnackBarInfo
 *   - mutations.showMessage   → actions.showMessage
 *   - mutations.hideMessage   → actions.hideMessage
 */
import { defineStore } from 'pinia'

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    info: {
      content: '',
      color: '',
      icon: '',
      timeout: null,
      show: false,
      position: {
        top: false,
        center: false,
        left: false,
        right: false,
      },
    },
  }),

  getters: {
    getSnackBarInfo: (state) => state.info,
  },

  actions: {
    showMessage (payload) {
      this.info = payload
      this.info.show = true
    },
    hideMessage () {
      this.info.show = false
    },
  },
})
